export const MONTHS = [
  { id: 1, label: "January", value: "1" },
  { id: 2, label: "February", value: "2" },
  { id: 3, label: "March", value: "3" },
  { id: 4, label: "April", value: "4" },
  { id: 5, label: "May", value: "5" },
  { id: 6, label: "June", value: "6" },
  { id: 7, label: "July", value: "7" },
  { id: 8, label: "August", value: "8" },
  { id: 9, label: "September", value: "9" },
  { id: 10, label: "October", value: "10" },
  { id: 11, label: "November", value: "11" },
  { id: 12, label: "December", value: "12" },
] as const;

export const INSULIN_DAILY_DOSE = [
  "3 times or more per day",
  "2 times or fewer per day",
] as const;

export const PLAN_TYPE_OPTIONS = ["PPO", "HMO", "Indemnity Policy", "Other"];

export const INSULIN_NAMES = [
  "Admelog",
  "Afrezza",
  "Apidra",
  "Aspart",
  "Basaglar",
  "Degludec",
  "Determir",
  "Fiasp",
  "Glargine",
  "Glulisine U-300",
  "Humalog",
  "Human NPH",
  "Human Regular",
  "Humulin N",
  "Humulin R",
  "Lantus",
  "Levemir",
  "Lispro",
  "Lyumjev",
  "Novolin N",
  "Novolin R",
  "Novolog",
  "ReliOn",
  "Soliqua",
  "Tujeo",
  "Triseba",
  "Xultophy",
];
export const YES_NO_RADIO_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const YES_NO_OPTIONS = {
  YES: "yes",
  NO: "no",
} as const;

export type YesNoOption = (typeof YES_NO_OPTIONS)[keyof typeof YES_NO_OPTIONS];

export const STATE_OPTIONS = [
  { id: "AL", label: "Alabama (AL)" },
  { id: "AK", label: "Alaska (AK)" },
  { id: "AZ", label: "Arizona (AZ)" },
  { id: "AR", label: "Arkansas (AR)" },
  { id: "CA", label: "California (CA)" },
  { id: "CO", label: "Colorado (CO)" },
  { id: "CT", label: "Connecticut (CT)" },
  { id: "DE", label: "Delaware (DE)" },
  { id: "FL", label: "Florida (FL)" },
  { id: "GA", label: "Georgia (GA)" },
  { id: "HI", label: "Hawaii (HI)" },
  { id: "ID", label: "Idaho (ID)" },
  { id: "IL", label: "Illinois (IL)" },
  { id: "IN", label: "Indiana (IN)" },
  { id: "IA", label: "Iowa (IA)" },
  { id: "KS", label: "Kansas (KS)" },
  { id: "KY", label: "Kentucky (KY)" },
  { id: "LA", label: "Louisiana (LA)" },
  { id: "ME", label: "Maine (ME)" },
  { id: "MD", label: "Maryland (MD)" },
  { id: "MA", label: "Massachusetts (MA)" },
  { id: "MI", label: "Michigan (MI)" },
  { id: "MN", label: "Minnesota (MN)" },
  { id: "MS", label: "Mississippi (MS)" },
  { id: "MO", label: "Missouri (MO)" },
  { id: "MT", label: "Montana (MT)" },
  { id: "NE", label: "Nebraska (NE)" },
  { id: "NV", label: "Nevada (NV)" },
  { id: "NH", label: "New Hampshire (NH)" },
  { id: "NJ", label: "New Jersey (NJ)" },
  { id: "NM", label: "New Mexico (NM)" },
  { id: "NY", label: "New York (NY)" },
  { id: "NC", label: "North Carolina (NC)" },
  { id: "ND", label: "North Dakota (ND)" },
  { id: "OH", label: "Ohio (OH)" },
  { id: "OK", label: "Oklahoma (OK)" },
  { id: "OR", label: "Oregon (OR)" },
  { id: "PA", label: "Pennsylvania (PA)" },
  { id: "RI", label: "Rhode Island (RI)" },
  { id: "SC", label: "South Carolina (SC)" },
  { id: "SD", label: "South Dakota (SD)" },
  { id: "TN", label: "Tennessee (TN)" },
  { id: "TX", label: "Texas (TX)" },
  { id: "UT", label: "Utah (UT)" },
  { id: "VT", label: "Vermont (VT)" },
  { id: "VA", label: "Virginia (VA)" },
  { id: "WA", label: "Washington (WA)" },
  { id: "WV", label: "West Virginia (WV)" },
  { id: "WI", label: "Wisconsin (WI)" },
  { id: "WY", label: "Wyoming (WY)" },
];

export const READER_OPTIONS = [
  "Freestyle Libre 14 Day",
  "Freestyle Libre 2",
  "Freestyle Libre 3",
  "Dexcom G6",
  "Dexcom G7",
];

export const TOTAL_FORM_STEPS = 8;

export const USER_STATE = {
  LOGGED_OUT: "loggedOut",
  LOGGED_IN: "loggedIn",
} as const;

export const PATIENT_STATUS = {
  NEW_PATIENT: "new_patient",
  ACTIVE: "active",
  DISQUALIFIED: "disqualified",
  TRANSFERRED: "transferred",
} as const;

export type PatientCaseStatus =
  (typeof PATIENT_STATUS)[keyof typeof PATIENT_STATUS];

export const PATIENT_DISQUALIFY_REASONS = {
  NOT_INSULIN: "not_insulin",
  NOT_PECOS: "not_pecos",
  SUPPLIER_NOT_CANCELLED: "supplier_not_cancelled",
  TIME_REQUIREMENT_NOT_MET_FOR_SENSORS: "time_requirement_not_met_for_sensors",
} as const;

export const PRODUCT_NAMES = {
  SENSORS_ONLY: "sensorsOnly",
  CGM: "cgm",
} as const;

export const AGENT_ROLES = {
  CALL_CENTER_AGENT: "call-center-agent",
  DATA_ENTRY_AGENT: "data-entry-agent",
  ADMINISTRATOR: "administrator",
} as const;

export type AgentRolesType = (typeof AGENT_ROLES)[keyof typeof AGENT_ROLES];
export const PATIENTS_LIST_STATUS = {
  INTAKE: "patient",
  DISQUALIFIED: "disqualified",
  TRANSFER: "transfer",
} as const;

export type PatientsListStatus =
  (typeof PATIENTS_LIST_STATUS)[keyof typeof PATIENTS_LIST_STATUS];

export const SENSORS_DELIVERY_METHODS = {
  SENT_TO_HOME: "sentToHome",
  PICKUP_AT_PHARMACY: "pickupAtPharmacy",
} as const;
